import * as React from 'react'
import { Spinner } from '@components/loaders/spinner'
import { formatPriceShort } from '@helpers/utils'

interface Props {
  price: number | string
  pricePrefix?: string
  priceItemClassName?: string
  isLoading: boolean
}

export const PriceWithSpinner = ({ isLoading, price, priceItemClassName, pricePrefix }: Props): JSX.Element => (
  <div>
    {isLoading ? (
      <Spinner className="text-primary spinner--small" color="gold" />
    ) : (
      <strong className={priceItemClassName}>
        {pricePrefix}
        {formatPriceShort(price)}
      </strong>
    )}
  </div>
)
